import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    backgroundColor: $theme.colors.primary,
    padding: $theme.sizing.scale600,
    borderRadius: '1.4rem',
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale600,
    color: $theme.colors.white,
    cursor: 'pointer'
}))

export const Title = styled('h2', ({ $theme }) => ({
    margin: 0,
    fontSize: '1.4rem',
    fontWeight: 700
}))

export const Subtitle = styled('p', ({ $theme }) => ({
    margin: 0,
    fontSize: '1.4rem',
    fontWeight: 400
}))

export const ReasonsContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale100
}))

export const ReasonText = styled('span', ({ $theme }) => ({
    fontSize: '1.2rem',
    fontWeight: 400,
    color: $theme.colors.white
}))

export const AdvantageLine = styled('div', ({ $theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: $theme.sizing.scale600,
    marginTop: '4px'
}))

export const CheckmarkIcon = styled('i', ({ $theme }) => ({
    color: $theme.colors.white,
    fontSize: $theme.sizing.scale500
}))

export const CTAText = styled('span', ({ $theme }) => ({
    fontSize: '1.4rem',
    fontWeight: 700,
    color: $theme.colors.white
}))
